import * as React from 'react';
import {Row} from 'antd';
import DataSelectorContainer from '../../../container/DataSelectorContainer';
import { ENABLE_FORCE_AUTH } from '../../../service/dataService';
import { Divider, Typography, Tag } from 'antd';
const { Title, Paragraph, Text, Link } = Typography;
export interface DescriptionViewProps {
    mode_id: number,
}

export interface DescriptionViewState {}

export default class DescriptionView extends React.Component<DescriptionViewProps, DescriptionViewState> {
    constructor(props: DescriptionViewProps) {
        super(props);
        this.state = {
            
        };
    }
    public render() {
        let generateHighlight = (text:any) => {
            return <span style={{"color":"purple"}}><strong>{text}</strong></span>
        }
        let generateMetricsDescription = () => {
            return <div> 
                

            <Title level={3}>Summary statistics of data</Title>
                <Paragraph>
                <strong>Accuracy:</strong> The API accuracy varies across different years. In the accuracy chart, the x-axis encodes the year, and the y-axis encodes {generateHighlight("the API accuracy for this year.")} The color indicates different APIs. You can select multiple APIs to check the different APIs' performance in different years. 
                </Paragraph>
                <Paragraph>
                <strong>Consistency:</strong> The API prediction results may vary across different years. In the consistency chart, each node represents one year of the prediction results of the API. The value on the edge between the nodes indicates {generateHighlight("the percentage of predictions remaining the same in those two years.")} The color of the edge indicates the consistency value, and the legend is shown at the bottom left of the chart. You can only select one API to check this chart.
                </Paragraph>
                <Paragraph>
                <strong>Confidence:</strong> The API confidence will also change across different years, even if the API in different years has the same prediction results. In the confidence chart, each node represents one year of the prediction results of the API. The value on the edge between the nodes indicates {generateHighlight("the average absolute confidence changes among all predictions in those two years.")} The color of the edge indicates the confidence change value, and the legend is shown at the bottom left of the chart. You can only select one API to check this chart.
                </Paragraph>
                <Paragraph>
                <strong>Fairness:</strong> The API may have different performances on the different subgroups of data (e.g., male and female). For such sensitive attributes, it is not desired that the API has different performance on them. In the fairness chart, the x-axis represents the sensitive attribute, and the y-axis represents {generateHighlight("the API accuracy on the subgroup specified by the attribute.")} The color of the bar indicates the year. You can select dataset COCO and only one API to check this chart.
                </Paragraph>
            </div>

            
        }
        let generateExploreDescription = () => {
            return <div> 
            
                <Title level={3}>Explore data</Title>
                <Paragraph>
                Different instances will have different confidences for one API in different years. For example, the Google API will recognize dog image with confidence 0.99 in 2020 while with confidence 0.65 in 2022. It is interesting to take a closer look at those instances. Confidence shifts for instances are visualized in confidence parallel sets. After selecting the filters, corresponding instances will be displayed.
                </Paragraph>
                <Paragraph>
                <strong>Confidence Parallel Sets:</strong> This chart uses each dimension to represent the individual year. Here, we consider a random subset of instances in the dataset to explore how confidence changes among those instances. In each dimension, there are several segments that represent different ranges of confidence. The length of the segment represents the percentage of instances in that range. The width of the ribbon plot between those dimensions represents the number of instances simultaneously satisfying the conditions in those years. {generateHighlight("You can click one segment or one ribbon plot to check the corresponding instances.")} Please select only one API to enable exploration.
                </Paragraph>
            </div>

            
        }
        if(this.props.mode_id === 1){
            return generateMetricsDescription();
        }else{
            return generateExploreDescription();
        }
    }
}
